import React from 'react';
import {
  FormsOverview,
  OverviewContent,
  OverviewTitle,
  OverviewText,
  OverviewActions,
  FormsPanel,
  PanelHeader,
  // PanelEyebrow,
  PanelStatus,
  FormsStatusList,
  FormsStatusItem,
  StatusIcon,
} from './Overview.styles';
import { FaFilePdf, FaEdit, FaTabletAlt, FaSearch } from 'react-icons/fa';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import SecondaryButton from '../../../Components/Buttons/SecondaryButton/SecondaryButton.component';
import { useNavigate } from 'react-router-dom';
const Overview = () => {
  const navigate = useNavigate();
  return (
    <FormsOverview>
      <OverviewContent>
        {/* <p className="eyebrowHeader">Digital Form Management</p> */}

        <OverviewTitle>
          Keep Workplace Forms Easier to Complete and Find
        </OverviewTitle>

        <OverviewText>
          Paper forms can be difficult to organize, search, and retrieve when
          you need information quickly. Yoda Safety Services can turn your
          existing PDF safety forms into digital forms your team can complete
          from an iPad, laptop, or other supported device.
        </OverviewText>

        <OverviewText>
          Completed forms stay organized in one place, making it easier to
          review submissions, filter records, and query the information your
          team has collected.
        </OverviewText>

        <OverviewActions>
          <PrimaryButton
            functionName={() => navigate('/contact-us')}
            span="Contact Us for Pricing"
          />

          <SecondaryButton
            functionName={() => navigate('/company-training')}
            span="Explore Company Training"
          />
        </OverviewActions>
      </OverviewContent>

      <FormsPanel>
        <PanelHeader>
          <div>
            {/* <PanelEyebrow>Digital Forms</PanelEyebrow> */}
            <h3>From PDF to Searchable Records</h3>
          </div>

          <PanelStatus>Subscription</PanelStatus>
        </PanelHeader>

        <FormsStatusList>
          <FormsStatusItem>
            <StatusIcon>
              <FaFilePdf />
            </StatusIcon>

            <div>
              <strong>Upload Your PDF</strong>
              <span>
                Start with the safety forms your company already uses.
              </span>
            </div>
          </FormsStatusItem>

          <FormsStatusItem>
            <StatusIcon>
              <FaEdit />
            </StatusIcon>

            <div>
              <strong>We Configure the Inputs</strong>
              <span>Your form is prepared for digital completion.</span>
            </div>
          </FormsStatusItem>

          <FormsStatusItem>
            <StatusIcon>
              <FaTabletAlt />
            </StatusIcon>

            <div>
              <strong>Complete Forms Online</strong>
              <span>Employees can fill them out on an iPad or laptop.</span>
            </div>
          </FormsStatusItem>

          <FormsStatusItem>
            <StatusIcon>
              <FaSearch />
            </StatusIcon>

            <div>
              <strong>Search the Data</strong>
              <span>
                Filter and query completed forms when you need answers.
              </span>
            </div>
          </FormsStatusItem>
        </FormsStatusList>
      </FormsPanel>
    </FormsOverview>
  );
};

export default Overview;
